import { Component } from '@angular/core';
@Component({
    selector: 'app-patient-footer',
    templateUrl: './patient-footer.component.html',
    styleUrls: ['./patient-footer.component.sass'],
    standalone: false
})
export class PatientFooterComponent {

}
